// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require core_post_webpack/sitewide_business_elements/bookmarks/_namespace
//= require_tree ./templates
//= require_tree ./models
//= require_tree ./views
//= require_tree ./behaviors
//= require_tree .
// MAGIC_DESPROCKET_START
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/bookmarks/_namespace.coffee')
require('javascripts/core_post_webpack/sitewide_business_elements/bookmarks/templates/modal_view_JST.wjs.js')
require('javascripts/core_post_webpack/sitewide_business_elements/bookmarks/templates/settings_link_JST.wjs.js')
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/bookmarks/models/bookmark.coffee')
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/bookmarks/views/bookmark_button_view.coffee')
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/bookmarks/behaviors/share_button.coffee')
require('sprocket-compat?this!javascripts/core_post_webpack/sitewide_business_elements/bookmarks/behaviors/undo_tracking.coffee')
// MAGIC_DESPROCKET_END
